export default function WithShouldRender({ value, object, children }) {
  return object[value] !== false ? children : null;
}
